export default {
  getQualifications: "getQualifications",
  removeQualifications: "removeQualifications",
  updateQualifications: "updateQualifications",
  addQualifications: "addQualifications",
  removeQualification: "removeQualification",
};
